<template>
  <div class="DropdownMenu">
    <div
      class="menu-mask"
      @click="$emit('close')" />

    <ul
      class="menu-items panel"
      @click="$emit('close')">
      <slot>
        <li>
          <Icon name="send" />
          <span>Default menu item</span>
        </li>
      </slot>
    </ul>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.DropdownMenu {
  cursor: pointer;
  position: relative;

  .menu-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: default;
  }
  ul.menu-items {
    margin: 0;
    width: 14em;
    list-style: none;
    position: absolute;
    left: -208px;
    top: 20px;
    z-index: 99999;
    font-size: 1.142em;

    li {
      color: var(--midnight-blue);
      padding-bottom: 1em;
      display: flex;
      svg {
        opacity: 0.25;
      }
      span {
        padding-left: 1em;
      }
      &.strong {
        svg {
          opacity: 1;
        }
      }
      &.sep {
        border-top: solid 1px var(--pale-grey-four);
        padding-top: 1em;
      }
    }
    li:last-child {
      padding-bottom: 0px;
    }
  }
}
</style>
